/**
 * Plain-language help for ops vs billable volume columns (D-009 catalogue).
 */

export const VOLUME_METRIC_HELP = Object.freeze({
  ops: {
    title: "Ops m³ (operational load units)",
    summary:
      "How heavy or bulky an item is for crew handling and truck loading. " +
      "This comes from the catalogue cube factor — it is not true room size.",
    example:
      "A 10-seater dining table might show 65 ops m³ but only 3.5 billable m³.",
    usedFor: "Enrichment totals, internal load planning, comparing items operationally.",
  },
  billable: {
    title: "Billable m³ (commercial volume)",
    summary:
      "Truck space used for pricing — truck band, transport charges, and quote totals. " +
      "Filled when the line matches a catalogue SKU with billableDefaultM3.",
    example:
      "Six dining chairs might total ~1.8 billable m³ once matched; unmatched lines show —.",
    usedFor: "Customer price, Mini/Medium/Large truck pick, corridor rates.",
  },
  inventorySection: {
    title: "Ops cubes vs billable m³",
    summary:
      "Each inventory line shows operational load (ops) and commercial volume (billable). " +
      "They often differ — large ops with small billable is normal for bulky furniture.",
    example:
      "Match uncertain lines with Use this SKU so billable m³ fills in and pricing is reliable.",
    usedFor: null,
  },
});

/**
 * @param {"ops"|"billable"|"inventorySection"} metric
 * @returns {typeof VOLUME_METRIC_HELP.ops}
 */
export function getVolumeMetricHelp(metric) {
  return VOLUME_METRIC_HELP[metric] || VOLUME_METRIC_HELP.ops;
}

/**
 * @param {"ops"|"billable"} metric
 * @returns {string}
 */
export function formatVolumeMetricTooltip(metric) {
  const help = getVolumeMetricHelp(metric);
  const lines = [help.summary, `Example: ${help.example}`];
  if (help.usedFor) {
    lines.push(`Used for: ${help.usedFor}`);
  }
  return lines.join("\n\n");
}
